import { useState } from "react";
import TextField from "@mui/material/TextField";
import List from "./List.js";
import "./SearchBar_Dictionary.css"

export default function SearchBarDictionary({data, onSelectItem }){

    const [inputText, setInputText] = useState("");


    let inputHandler = (e) => {

        //convert input text to lower case

        setInputText(e.target.value.toLowerCase());
    
    };

    return(

        <div className= "search-bar-container">
            <div className="blue-header-dict">
        
               
                {/*<h1>Search</h1>*/}
                <div className="SearchBarPanel">
                   <TextField
                    id="outlined-basic"
                    variant="outlined"
                    fullWidth
                    value={inputText}
                    onChange={inputHandler}
                    placeholder="Type something to search..."
                    />
                 <List 
                    input={inputText} 
                    data={data}
                    onSelectItem={onSelectItem}
                />
                </div>
            </div>
        </div>

);

}

//Resources
    //How to add a search bar in react
        //https://builtin.com/articles/react-search-bar